module.exports = __webpack_public_path__ + "static/media/download_appstore.8bd7aa8d.png";